'use strict';

/**
 *
 * @name: apiLoveService
 *
 */

function ApiLoveService($rootScope, $http) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  function lovePost(postId, rating) {

    var data = {
      UserId: $rootScope.profile.id,
      PostId: postId,
      rating: rating
    };

    var target = $rootScope.apiUrlNew + '/post-love';

    return $http.post(target, data);
  }

  function loveUpdate(postId, rating) {

    var data = {
      rating: rating
    };

    var target = $rootScope.apiUrlNew + '/post-love/' + postId;

    return $http.put(target, data);
  }

  function lovePlaylist(playlistId, rating) {

    var data = {
      UserId: $rootScope.profile.id,
      PlaylistId: playlistId,
      rating: rating
    };

    var target = $rootScope.apiUrlNew + '/playlist-love';

    return $http.post(target, data);
  }

  function lovePlaylistUpdate(playlistId, rating) {

    var data = {
      rating: rating
    };

    var target = $rootScope.apiUrlNew + '/playlist-love/' + playlistId;

    return $http.put(target, data);
  }

  function unlovePost(postId) {

    var target = $rootScope.apiUrlNew + '/post-love?' +
      '&UserId=' + $rootScope.profile.id + '&PostId=' + postId;

    return $http.delete(target);
  }

  function unlovePlaylist(playlistId) {

    var target = $rootScope.apiUrlNew + '/playlist-love?' +
      '&UserId=' + $rootScope.profile.id + '&PlaylistId=' + playlistId;

    return $http.delete(target);
  }

  /**
   *
   * @PRIVATE
   *
   */

  return {
    lovePost: lovePost,
    loveUpdate: loveUpdate,
    lovePlaylist: lovePlaylist,
    lovePlaylistUpdate: lovePlaylistUpdate,
    unlovePost: unlovePost,
    unlovePlaylist: unlovePlaylist,
  };
}

export default ApiLoveService;



// WEBPACK FOOTER //
// ./app/components/_api/love.service.js